export const DISALLOWED_WORDS_LIST_KEY = 'DISALLOWED_WORDS_LIST';
export const DISALLOWED_WORDS_ONE_KEY = 'DISALLOWED_WORDS_ONE_KEY';
